import companyService from '@/service/companyService'

export const namespaced = true;

// const getDefaultState = () => {
//   return {
//     lawyer: [],
//   };
// };

export const state = () => ({
  contracts: [],
  contracts1400: [],
  contracts1401: [],
  contracts1402: [],
  contracts1403: [],
  contracts01: [],
  contracts02: [],
  factors: [],
  factors99: [],
  factors98: [],
  factors01: [],
  racks: [],

});

// export const state = getDefaultState();

export const getters = {
  getContracts(state) {
    return state.contracts
  },
  getContracts1400(state) {
    return state.contracts1400
  },
  getContracts1401(state) {
    return state.contracts1401
  },
  getContracts1402(state) {
    return state.contracts1402
  },
  getContracts1403(state) {
    return state.contracts1403
  },
  getContracts01(state) {
    return state.contracts01
  },
  getContracts02(state) {
    return state.contracts02
  },
  getFactors(state) {
    return state.factors
  },
  getFactors99(state) {
    return state.factors99
  },
  getFactors98(state) {
    return state.factors98
  },
  getFactors01(state) {
    return state.factors01
  },
  getRacks(state) {
    return state.racks
  },

}


export const mutations = {
  SET_LAWYER(state, payload) {
    state.lawyer = payload
  },
  SET_CONTRACTS(state, payload) {
    state.contracts = payload
  },
  SET_CONTRACTS1400(state, payload) {
    state.contracts1400 = payload
  },
  SET_CONTRACTS1401(state, payload) {
    state.contracts1401 = payload
  },
  SET_CONTRACTS1402(state, payload) {
    state.contracts1402 = payload
  },
  SET_CONTRACTS1403(state, payload) {
    state.contracts1403 = payload
  },
  SET_CONTRACTS_01(state, payload) {
    state.contracts01 = payload
  },
  SET_CONTRACTS_02(state, payload) {
    state.contracts02 = payload
  },
  SET_FACTORS(state, payload) {
    state.factors = payload
  },
  SET_FACTORS99(state, payload) {
    state.factors99 = payload
  },
  SET_FACTORS98(state, payload) {
    state.factors98 = payload
  },
  SET_FACTORS01(state, payload) {
    state.factors01 = payload
  },
  SET_RACKS(state, payload) {
    state.racks = payload
  },
  SET_RACKS403(state, payload) {
    state.racks = payload
  },


};


export const actions = {


  async fetchContracts({commit}, payload) {
    const {data} = await companyService().fetchContracts(payload);
    commit("SET_CONTRACTS", data.data);
    return data.data;
  },
  async fetchContracts1400({commit}, payload) {
    const {data} = await companyService().fetchContracts1400(payload);
    commit("SET_CONTRACTS1400", data.data);
    return data.data;
  },
  async fetchContracts1401({commit}, payload) {
    const {data} = await companyService().fetchContracts01(payload);
    commit("SET_CONTRACTS1401", data.data);
    return data.data;
  },
  async fetchContracts1402({commit}, payload) {
    const {data} = await companyService().fetchContracts02(payload);
    commit("SET_CONTRACTS1402", data.data);
    return data.data;
  },
  async fetchContracts1403({commit}, payload) {
    const {data} = await companyService().fetchContracts03(payload);
    commit("SET_CONTRACTS1403", data.data);
    return data.data;
  },
  async fetchContracts01({commit}, payload) {
    const {data} = await companyService().fetchContracts01(payload);
    commit("SET_CONTRACTS_01", data.data);
    return data.data;
  },
  async fetchContracts02({commit}, payload) {
    const {data} = await companyService().fetchContracts02(payload);
    commit("SET_CONTRACTS_02", data.data);
    return data.data;
  },

  async fetchFactors({commit}, payload) {
    const {data} = await companyService().fetchFactors(payload);
    commit("SET_FACTORS", data.data);
    return data.data;
  },
  async fetchFactors99({commit}, payload) {
    const {data} = await companyService().fetchOtherFactors(payload);
    commit("SET_FACTORS99", data.data);
    return data.data;
  },
  async fetchFactors98({commit}, payload) {
    const {data} = await companyService().fetchOtherFactors(payload);
    commit("SET_FACTORS98", data.data);
    return data.data;
  },
  async fetchFactors01({commit}, payload) {
    const {data} = await companyService().fetchOtherFactors(payload);
    commit("SET_FACTORS01", data.data);
    return data.data;
  },
  async fetchRacks({commit}, payload) {
    const {data} = await companyService().fetchRacks(payload);
    commit("SET_RACKS", data.data);
    return data.data;
  },
  async fetchRacks403({commit}, payload) {
    const {data} = await companyService().fetchRacks403(payload);
    commit("SET_RACKS403", data.data);
    return data.data;
  },

};
